import { SelectionAny } from './internal';
export class SelectionRomanization extends SelectionAny {
    getMethod() {
        return this.get("TYPE" /* Tag.Type */);
    }
}
//# sourceMappingURL=SelectionRomanization.js.map